<template>
  <MainLayout>
    <template #content>
      <div class="content-container flex flex-col w-full px-8 py-8">
        <div class="prose max-w-none text-sm leading-6">
          <h1 class="text-2xl font-semibold mb-4">Impressum</h1>
          <p>
            Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und
            Offenlegungspflicht laut §25 Mediengesetz.
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">Epasnets GmbH</h2>
          <p>
            Leopoldstraße 20,<br />
            6020 Innsbruck,<br />
            Österreich
          </p>

          <p>
            <strong>Unternehmensgegenstand:</strong> IT Dienstleistungen<br />
            <strong>UID-Nummer:</strong> ATU75564569<br />
            <strong>Firmenbuchnummer:</strong> FN 533386 t<br />
            <strong>Firmenbuchgericht:</strong> Landesgericht Innsbruck<br />
            <strong>Firmensitz:</strong> Innsbruck
          </p>

          <p>
            <strong>Tel.:</strong> +43 676 750011<br />
            <strong>E-Mail:</strong> <a href="mailto:hallo@epasnets.com">hallo@epasnets.com</a>
          </p>

          <p>
            <strong>Mitglied bei:</strong> WKO<br />
            <strong>Berufsrecht:</strong>
            <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer">www.ris.bka.gv.at</a>
          </p>

          <p>
            <strong>Aufsichtsbehörde/Gewerbebehörde:</strong> Bezirkshauptmannschaft Innsbruck<br />
            <strong>Berufsbezeichnung:</strong> Die Verwaltung und der Vertrieb von Onlineshops<br />
            <strong>Verleihungsstaat:</strong> Österreich
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">Geschäftsführer</h2>
          <p>Florian Pohl, Jeremias Fuchs</p>

          <p class="text-gray-500 mt-2">
            Quelle: Erstellt mit dem
            <a href="https://www.firmenwebseiten.at/impressum-generator/" target="_blank" rel="noopener noreferrer"
              >Impressum Generator</a
            >
            von
            <a href="https://www.firmenwebseiten.at/" target="_blank" rel="noopener noreferrer">firmenwebseiten.at</a>
            in Kooperation mit
            <a href="https://www.schoenheitsmagazin.at" target="_blank" rel="noopener noreferrer"
              >schoenheitsmagazin.at</a
            >
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">EU-Streitschlichtung</h2>
          <p>
            Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie
            über die Online-Streitbeilegungsplattform (OS-Plattform) informieren. Verbraucher haben die Möglichkeit,
            Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter
            <a href="http://ec.europa.eu/odr?tid=221128197" target="_blank" rel="noopener noreferrer">
              http://ec.europa.eu/odr?tid=221128197
            </a>
            zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.
          </p>
          <p>
            Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">Haftung für Inhalte dieser Webseite</h2>
          <p>
            Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns, korrekte und aktuelle
            Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser
            Webseite übernehmen, speziell für jene, die seitens Dritter bereitgestellt wurden.
          </p>
          <p>
            Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten wir Sie, uns umgehend zu
            kontaktieren. Sie finden die Kontaktdaten im Impressum.
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">Haftung für Links auf dieser Webseite</h2>
          <p>
            Unsere Webseite enthält Links zu anderen Webseiten, für deren Inhalt wir nicht verantwortlich sind. Haftung
            für verlinkte Websites besteht laut
            <a
              href="https://www.ris.bka.gv.at/Dokument.wxe?Abfrage=Bundesnormen&Dokumentnummer=NOR40025813"
              target="_blank"
              rel="noopener noreferrer"
              >§ 17 ECG</a
            >
            für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche
            Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns
            Rechtswidrigkeiten bekannt werden.
          </p>
          <p>
            Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitten wir Sie, uns zu kontaktieren. Sie
            finden die Kontaktdaten im Impressum.
          </p>

          <h2 class="text-lg font-semibold mt-6 mb-2">Urheberrechtshinweis</h2>
          <p>
            Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Falls notwendig,
            werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.
          </p>

          <h3 class="text-base font-semibold mt-6 mb-2">Quellen</h3>
          <ul>
            <li>
              <a href="https://www.flaticon.com/free-icon/engineering_3079165" target="_blank" rel="noopener noreferrer"
                >Engineering Icon</a
              >
            </li>
            <li>
              <a
                href="https://www.flaticon.com/free-icon/transparency_1355174"
                target="_blank"
                rel="noopener noreferrer"
                >Transparency Icon</a
              >
            </li>
            <li>
              <a
                href="https://www.flaticon.com/de/kostenloses-icon/gepruft_2089634"
                target="_blank"
                rel="noopener noreferrer"
                >Geprüft Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/profits_843734" target="_blank" rel="noopener noreferrer"
                >Profitability Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/snap_3798326" target="_blank" rel="noopener noreferrer"
                >Snap Icon</a
              >
            </li>
            <li>
              <a
                href="https://www.flaticon.com/free-icon/directional-arrows-signals-on-a-pole_35195"
                target="_blank"
                rel="noopener noreferrer"
                >Directional Arrows Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/heart_1692130" target="_blank" rel="noopener noreferrer"
                >Heart Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/generosity_2646179" target="_blank" rel="noopener noreferrer"
                >Generosity Icon</a
              >
            </li>
            <li>
              <a
                href="https://www.flaticon.com/free-icon/planet-earth_1598238"
                target="_blank"
                rel="noopener noreferrer"
                >Planet Earth Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/treasure_1355818" target="_blank" rel="noopener noreferrer"
                >Treasure Icon</a
              >
            </li>
            <li>
              <a href="https://www.flaticon.com/free-icon/wallet_591983" target="_blank" rel="noopener noreferrer"
                >Wallet Icon</a
              >
            </li>
          </ul>
        </div>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import MainLayout from "_layouts";

export default {
  components: { MainLayout },
};
</script>
<style scoped>
.prose a {
  text-decoration: underline;
  text-decoration-color: currentColor;
}
</style>
